import { CHANNELS } from "@/data/onboarding";
import { StepShell } from "../OnboardingPrimitives";

export default function StepChannels({ state, toggleArrayItem }) {
  return (
    <StepShell
      stepId="channels"
      eyebrow="Step 04 · Your channels"
      title={<>Where do you want to <span className="italic text-aurora">show up?</span></>}
    >
      <div className="space-y-5">
        <p className="text-sm text-neutral-600">Pick the channels you actually use. The Growth Engine will draft for these first.</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
          {CHANNELS.map((c) => {
            const active = state.channels.includes(c.id);
            return (
              <button
                key={c.id}
                type="button"
                data-testid={`onboarding-channel-${c.id}`}
                onClick={() => toggleArrayItem("channels", c.id)}
                className={`px-4 py-3 rounded-sm text-sm transition border ${
                  active
                    ? "border-transparent aurora-border bg-[#FAFAFA] text-neutral-900"
                    : "border-neutral-200 hover:border-[#D4AF37]/60 text-neutral-600"
                }`}
              >
                {c.label}
              </button>
            );
          })}
        </div>
        <p className="text-xs text-neutral-500 leading-relaxed pt-4">
          Next up: pick a plan and the Studio will calibrate around what you just told us.
        </p>
      </div>
    </StepShell>
  );
}
